import { put, call } from 'redux-saga/effects';

import { Types } from './actions';

import ReincorporationRepository from '../../../../repositories/ReincorporationRepository';
import ReincorporationDataRepository from '../../../../../data/repositories/ReincorporationDataRepository';

export default function* execute(action: any): any {
  try {
    const { procedureId, requestId, deliveryMode, career } = action;

    yield put({ type: Types.ACTIVATE_PAYMENT_REQUEST });
    const reincorporationRepository: ReincorporationRepository =
      new ReincorporationDataRepository();

    const activatePaymentReincorporationResponse = yield call(
      reincorporationRepository.activatePaymentReincorporation,
      procedureId,
      requestId,
      deliveryMode,
      career
    );

    if (
      !activatePaymentReincorporationResponse ||
      activatePaymentReincorporationResponse?.error ||
      activatePaymentReincorporationResponse.requestId === undefined
    ) {
      yield put({
        type: Types.ACTIVATE_PAYMENT_FAILURE,
        error: 'Error en activación de pago'
      });
      return;
    }

    yield put({
      type: 'GET_STUDENT_PROCEDURE_STATUS',
      procedureId,
      requestId: action.requestId // + 1 // (config.DATASOURCE_ENV === 'MOCK' ? 1 : 0)
    });

    yield put({
      type: Types.ACTIVATE_PAYMENT_SUCCESS,
      data: activatePaymentReincorporationResponse
    });
  } catch (error) {
    yield put({
      type: Types.ACTIVATE_PAYMENT_FAILURE,
      error: 'Ocurrió un error en la activación del pago.'
    });
  }
}
